import { Modal, Divider, Button } from 'antd';

class HelpModalContentHeader extends React.Component {
    constructor(props) { super(props); }
    render() {
        const { type } = this.props;
        switch(type) {
            default: return null;
        }
    }
}

class HelpModalContentBody extends React.Component {
    constructor(props) { super(props); }
   
    render() {
        const { type } = this.props;
        console.log("Type: ", type);
        // switch(type) {
            
        //     default: return null;
        // }
    }
}

export default class extends React.Component {
    state = { visible: false }
    constructor(props) { super(props); }

    render() {
        console.log('>>>>>> HelpModalContent this.props: ', this.props);
        const { visible } = this.state;
        
        return (
            <Modal 
                visible={visible}
                centered={true}
                footer={null}
                closable={false}
                bodyStyle={{ padding: '10px' }}
            >
                <HelpModalContentHeader {...this.props} />
                <Divider type='horizontal' style={{ margin: '10px 0px' }} />
                <HelpModalContentBody {...this.props} />
                <div>
                    <Divider type='horizontal' style={{ margin: '10px 0px' }} />
                    <div style={{ textAlign: 'right' }}>
                        <Button 
                            type='danger' 
                            size='small' 
                            icon='close-circle'
                            style={{ 
                                width: '120px', 
                                borderRadius: '20px'
                            }}
                        >
                            {'Close'}
                        </Button>
                    </div>
                </div>
            </Modal>
        );
    }
}